import type { Epic } from 'Flux/index.js'
import { organizationSlice } from 'Flux/Slice/Organization/OrganizationSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import type { AjaxError } from 'rxjs/ajax'

export const UpdateOrganizationEpic: Epic = (action$, state$, { [organizationSlice.name]: organization, OrganizationRepository }) =>
  action$.pipe(
    filter(organization.updateOrganizationRequest.match),
    mergeMap((action) => {
      return OrganizationRepository.updateOrganization({
        organizationId: action.payload.organizationId,
        name: action.payload.name,
        description: action.payload.description,
        type: action.payload.type,
        isPublic: action.payload.isPublic,
        homepage: action.payload.homepage,
        country: action.payload.country,
        specialities: action.payload.specialities,
        contactEmail: action.payload.contactEmail,
        defaultSampleConfigurationType: action.payload.defaultSampleConfigurationType,
        defaultRedlistMode: action.payload.defaultRedlistMode,
        defaultProcessingType: action.payload.defaultProcessingType
      }).pipe(
        mergeMap((response) => of(organization.updateOrganizationSuccess({ organization: response }))),
        catchError((error: AjaxError) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(organization.updateOrganizationFailure({ error }))
          })
        )
      )
    })
  )
